import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Image } from 'antd'
import './style.less'
import { CloseCircleOutlined, EnvironmentOutlined, PhoneOutlined } from '@ant-design/icons'
import { setShowPopupMarkerId } from '@/store/slice/marker'
import { gmapSeachUrl } from '@data/map.js'
import storeImg from '@images/pin.png'

const Marker = (props) => {
  const { store, onClick } = props
  const dispatch = useDispatch()
  const [isPopupShow, setIsPopupShow] = useState(false)
  const markerId = useSelector(state => state.marker.showPopupId)

  const onMarkerClick = useCallback(() => {
    onClick(store)
    setIsPopupShow(true)
  }, [store, onClick])

  const onPopupClose = useCallback(() => {
    setIsPopupShow(false)
    dispatch(setShowPopupMarkerId(null))
  }, [dispatch])

  // 只要isPopupShow是true 或是markerId相等 就show popup
  const isShow = markerId === store.storeid || isPopupShow
  const popup = !isShow ? null : (
    // the ant design Tooltip's html code
    // I add 'Marker-Popup' class at root element
    <div className="Marker-popup ant-popover ant-popover-placement-top">
      <div className="ant-popover-content">
        <div className="ant-popover-arrow">
          <span className="ant-popover-arrow-content"></span>
        </div>
        <div className="ant-popover-inner" role="tooltip">
          <div className="ant-popover-title">
            {/* Title Start */}
            <div className="d-flex align-center justify-between text-nowrap">
              <span>{props.store.channel} - {store.name}門市</span>
              <CloseCircleOutlined className="ml-3" onClick={onPopupClose} />
            </div>
            {/* Title End */}
          </div>
          <div className="ant-popover-inner-content">
            {/* Content Start */}
            <section>
              <div className="text-nowrap">
                <EnvironmentOutlined />
                <a className="ml-3 text-underline" href={gmapSeachUrl(store.address)} target="_blank" rel="noreferrer">{store.address}</a>
              </div>
              <div className="text-nowrap">
                <PhoneOutlined />
                <a className="ml-3 text-underline" href={`tel:${store.phone}`}>{store.phone}</a>
              </div>
            </section>
            {/* Content End */}
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="Marker-wapper">
      {popup}
      <div className="Marker text-center" onClick={onMarkerClick}>
        <Image width="24px" src={storeImg} preview={false} />
        <div className="Marker-label font-bold text-nowrap pa-1">{store.name}門市</div>
      </div>
    </div>
  )
}

// export default Marker
export default React.memo(Marker)